/* eslint-disable callback-return */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../pages/Home.vue';
import ForgotPassword from '../pages/ForgotPassword.vue';
import SignupSelection from '../pages/SignupSelection.vue';
import AgencySignup from '../pages/agency/AgencySignup.vue';
import BusinessSignup from '../pages/business/BusinessSignup.vue';
import IndividualSignup from '../pages/IndividualSignup.vue';
import Login from '../pages/Login.vue';
import Reset from '../pages/ResetPassword.vue';
import AdminSignup from '../pages/admin/AdminSignup.vue';
import RequestNewToken from '../pages/RequestNewToken.vue';
import Confirm from '../pages/Confirm.vue';
import MainDashboard from '../pages/MainDashboard';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else {
        next('/user/dashboard');
      }
    }
  },
  {
    path: '/signup',
    name: 'SignupSelection',
    component: SignupSelection
  },
  {
    path: '/signup/agency',
    name: 'AgencySignup',
    component: AgencySignup
  },
  {
    path: '/signup/business',
    name: 'BusinessSignup',
    component: BusinessSignup
  },
  {
    path: '/signup/individual',
    name: 'IndividualSignup',
    component: IndividualSignup
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/reset',
    name: 'Reset',
    component: Reset
  },
  {
    path: '/request-new-token',
    name: 'RequestNewToken',
    component: RequestNewToken
  },
  {
    path: '/confirm',
    name: 'Confirm',
    component: Confirm
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../pages/About.vue')
  // },
  {
    path: '/forgot-password',
    name: 'Forgot-Password',
    component: ForgotPassword
  },
  {
    path: '/signup/admin/onboarding1',
    name: 'Admin-Signup',
    component: AdminSignup
  },
  {
    path: '/user/dashboard',
    name: 'Dashboard',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/jobs',
    name: 'Jobs',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/jobs/:companyName/jobs',
    name: 'Company Jobs',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') === 'normal-user') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/jobs/:id/apply',
    name: 'Applicant Job Detail',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') !== 'normal-user') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/jobs/:id/share',
    name: 'Job Share',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        localStorage.setItem('sharedJobLinkId', to.params.id);
        next('/login');
      } else if (localStorage.getItem('accountType') !== 'normal-user') {
        next('/user/dashboard');
      } else {
        next(`/user/jobs/${to.params.id}/apply`);
      }
    }
  },
  {
    path: '/user/jobs/:id/review',
    name: 'Job Review',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        localStorage.setItem('createdJobLinkId', to.params.id);
        next('/login');
      } else if (localStorage.getItem('accountType') === 'normal-user') {
        next('/user/dashboard');
      } else {
        next(`/user/jobs/${to.params.id}/detail`);
      }
    }
  },
  {
    path: '/user/jobs/:jobID/detail',
    name: 'Job Detail',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') === 'normal-user') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  },{
    path: '/user/jobs/create',
    name: 'Post Job',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') === 'normal-user') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/businesses',
    name: 'Businesses',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') !== 'admin') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/candidates',
    name: 'Candidates',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') !== 'admin') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/agencies',
    name: 'Agencies',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') !== 'admin') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/applications',
    name: 'Applications',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/settings',
    name: 'Settings',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/applications/:applicationId/review',
    name: 'Application',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') === 'normal-user') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  },
  {
    path: '/user/jobs/:jobId/edit',
    name: 'Edit Job',
    component: MainDashboard,
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('isAuthenticated')) {
        next('/login');
      } else if (localStorage.getItem('accountType') === 'normal-user') {
        next('/user/dashboard');
      } else {
        next();
      }
    }
  }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

export default router;
